import { z } from 'zod';
import { nativeAppVersionSchema } from './nativeAppVersionSchema';

export const nativeAppVersionTypeSchema = z.object({
  appStore: nativeAppVersionSchema.nullable().default(null),
  googlePlay: nativeAppVersionSchema.nullable().default(null),
});
